import AdminLayout from '../AdminLayout';

const CILayout = ({ children }) => {
  return <AdminLayout>{children}</AdminLayout>;
};

export default CILayout;